import request from '@/utils/request'

import { f10url } from './config'
type dataType = any
export default {
  // 创建个股笔记
  getMsgboardCreateNote(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/MsgboardCreateNote',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 更新个股笔记
  getMsgboardUpdateNote(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/MsgboardUpdateNote',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 个股笔记列表
  getMsgboardNoteList(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/MsgboardNoteList',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 个股笔记详情
  getMsgboardNote(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/MsgboardNote',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 删除个股笔记
  getMsgboardDeleteNote(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/MsgboardDeleteNote',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  },
  // 个股笔记显示在k线上的交易日
  getMsgboardNoteTradeDays(data: dataType): Promise<{
    response?: Response
  }> {
    return request({
      url: f10url + '/infoapi/v2/MsgboardNoteTradeDays',
      method: 'post',
      data: data.data,
      headers: data.headers
    })
  }
}
